import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_app",
  ref: "addAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_app_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_app_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_app_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_app_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_15 = { class: "row mb-7" }
const _hoisted_16 = { class: "col-md-6 form-group" }
const _hoisted_17 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_20 = { class: "form-group mb-7" }
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = { class: "form-group mb-7" }
const _hoisted_23 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_24 = { class: "form-group mb-7" }
const _hoisted_25 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_26 = { class: "modal-footer flex-center" }
const _hoisted_27 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_28 = { class: "indicator-label" }
const _hoisted_29 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_30 = { class: "indicator-progress" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add") + _ctx.t("permissions.app")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("permissions.systemStatus")), 1),
                    _createVNode(_component_el_form_item, { prop: "status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.formData.status,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                          "active-value": 10,
                          "inactive-value": 25,
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("permissions.appName")), 1),
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                          type: "text",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("permissions.shortKey")), 1),
                    _createVNode(_component_el_form_item, { prop: "short_key" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.short_key,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_key) = $event)),
                          type: "text",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("permissions.frontendBaseUrl")), 1),
                  _createVNode(_component_el_form_item, { prop: "frontend_base_url" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.frontend_base_url,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.frontend_base_url) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("permissions.restApiUrl")), 1),
                  _createVNode(_component_el_form_item, { prop: "rest_api_url" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.rest_api_url,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.rest_api_url) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("permissions.rpcNamespace")), 1),
                  _createVNode(_component_el_form_item, { prop: "rpc_namespace" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.rpc_namespace,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.rpc_namespace) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("permissions.overallNotes")), 1),
                  _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.overall_notes,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, _toDisplayString(_ctx.t("common.discard")), 1),
              _createElementVNode("button", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.submit")) + " ", 1),
                  _createElementVNode("span", _hoisted_29, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _createElementVNode("span", _hoisted_30, [
                  _createTextVNode("' " + _toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_31
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}